export enum PaymentMethod {
  CASH = 'cash',
  CARD = 'card',
  TRANSFER = 'transfer',
  OTHER = 'other',
}

export interface Payment {
  id: number;
  rental: number;
  amount: string;
  payment_method: PaymentMethod;
  payment_method_display: string;
  is_paid: boolean;
  payment_date: string | null;
  description: string;
  created: string;
  modified: string;
}

export interface PaymentCreate {
  rental: number;
  amount: string;
  payment_method: PaymentMethod;
  is_paid?: boolean;
  payment_date?: string | null;
  description?: string;
}